import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Debate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { topic, selectedStyle } = location.state || {};

  const [side, setSide] = useState('');
  const [userMessage, setUserMessage] = useState('');
  const [chat, setChat] = useState([]);
  const [loading, setLoading] = useState(false);

  // Step 1: Ask for side selection
  if (!side) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <button
          className="btn btn-small btn-success position-absolute rounded-circle"
          style={{ top: 16, left: 16, zIndex: 2 }}
          onClick={() => navigate(-1)}
        >
          ←
        </button>
        <h2>Pick Your Side</h2>
        <p>Topic: <strong>{topic}</strong></p>
        <div className="d-flex gap-3 mt-4">
          <button className="btn btn-outline-success px-4" onClick={() => setSide('pro')}>Pro</button>
          <button className="btn btn-outline-success px-4" onClick={() => setSide('con')}>Con</button>
        </div>
      </div>
    );
  }

  // Step 2: Chat window
  const handleSend = async () => {
    if (!userMessage.trim()) return;
    const newChat = [...chat, { sender: 'user', text: userMessage }];
    setChat(newChat);
    setUserMessage('');
    setLoading(true);
    try {
      const res = await axios.post('/debate/respond', {
        topic,
        side,
        user_message: userMessage,
        selectedStyle
      });
      const botText = res.data?.choices?.[0]?.message?.content || 'No response from bot.';
      setChat([...newChat, { sender: 'bot', text: botText }]);
    } catch (err) {
      setChat([...newChat, { sender: 'bot', text: 'Error: Could not get response.' }]);
    }
    setLoading(false);
  };

  return (
    <div className="d-flex flex-column align-items-center vh-100 px-3" style={{ maxWidth: 600, margin: '0 auto' }}>
      <button
        className="btn btn-small btn-success btn-rounded position-absolute rounded-circle"
        style={{ top: 16, left: 16, zIndex: 2 }}
        onClick={() => navigate(-1)}
      >
        ←
      </button>
      <h4 className="my-3">Debate: <span className="text-success">{topic}</span></h4>
      <div className="mb-2">Side: <strong>{side === 'pro' ? 'Pro' : 'Con'}</strong> | Style: <strong>{selectedStyle}</strong></div>
      <div className="flex-grow-1 w-100 mt-3 border" style={{ background: '#f8f9fa', borderRadius: 8, padding: 16, overflowY: 'auto', minHeight: 300, maxHeight: 400 }}>
        {chat.length === 0 && <div className="text-muted">Start the debate by sending a message!</div>}
        {chat.map((msg, idx) => (
          <div key={idx} className={`mb-2 d-flex ${msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'}`}>
            <div
              className={`p-2 rounded ${msg.sender === 'user' ? 'bg-primary text-white' : 'bg-light border'}`}
              style={{ maxWidth: '80%' }}
            >
              {msg.text}
            </div>
          </div>
        ))}
        {loading && (
          <div className="mb-2 d-flex justify-content-start">
            <div className="p-2 rounded bg-light border" style={{ maxWidth: '80%' }}>
              <em>Bot is typing...</em>
            </div>
          </div>
        )}
      </div>
      <div className="w-100 d-flex">
        <input
          className="form-control me-2"
          type="text"
          placeholder="Type your message..."
          value={userMessage}
          onChange={e => setUserMessage(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !loading) handleSend(); }}
          disabled={loading}
        />
        <button className="btn btn-success" onClick={handleSend} disabled={loading || !userMessage.trim()}>
          Debate
        </button>
      </div>
    </div>
  );
};

export default Debate;